"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNotHubspotSupportEmail = isNotHubspotSupportEmail;
exports.isValidEmail = isValidEmail;
exports.isValidDomain = isValidDomain;
exports.isValidRequiredProperties = isValidRequiredProperties;
exports.isValidPropertyValue = isValidPropertyValue;
exports.getDomain = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

var _hubspotPatternValidationPatterns = _interopRequireDefault(require("hubspot.PatternValidation.patterns.EmailAddress"));

var _hubspotPatternValidationPatterns2 = _interopRequireDefault(require("hubspot.PatternValidation.patterns.Domain"));

var _PropertyTypes = require("customer-data-objects/property/PropertyTypes");

var _PropertyIdentifier = require("customer-data-objects/property/PropertyIdentifier");

function isNotHubspotSupportEmail(email) {
  return !/(support\.hubspot\.com)/g.test(email);
}

function isValidEmail(email) {
  return email && _hubspotPatternValidationPatterns.default.test(email) && isNotHubspotSupportEmail(email);
}

var getDomain = (0, _memoize.default)(function (url) {
  if (!url) {
    return undefined;
  }

  url = url.replace(/https?:\/\//i, '').replace(/(www\.)?/i, '');

  if (url.indexOf('/') === -1) {
    return url;
  }

  return url.split('/')[0];
});
exports.getDomain = getDomain;

function isValidDomain(domain) {
  domain = getDomain(domain);

  if (!domain) {
    return false;
  }

  return _hubspotPatternValidationPatterns2.default.test(domain);
}

function isValidRequiredProperties(requiredProps, propertyValues, availableProps) {
  if (!requiredProps) {
    return true;
  }

  return requiredProps.every(function (prop) {
    var value = propertyValues.get(prop);
    var valueAsString = "" + value;
    var propertyType = availableProps.getIn([prop, 'type']);
    var hasExternalOptions = availableProps.getIn([prop, 'externalOptions']);
    var isValid;

    if (propertyType === _PropertyTypes.ENUMERATION && !hasExternalOptions) {
      var values = (0, _PropertyIdentifier.isMultienum)(availableProps.get(prop).toJS()) ? valueAsString.split(';') : [valueAsString];
      var options = availableProps.getIn([prop, 'options']);
      isValid = options.some(function (option) {
        return values.includes(option.get('value'));
      });
    } else {
      var trimmedValue;

      if (valueAsString) {
        trimmedValue = valueAsString.trim();
      }

      isValid = value !== undefined && value !== null && trimmedValue && trimmedValue.length > 0;
    }

    return isValid;
  });
}

function isValidPropertyValue(property, value) {
  if (value && (0, _PropertyIdentifier.isDate)(property)) {
    return !isNaN(Number(value));
  }

  return true;
}